/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExtractedDataResponseMetadata } from './ExtractedDataResponseMetadata';
import {
    ExtractedDataResponseMetadataFromJSON,
    ExtractedDataResponseMetadataFromJSONTyped,
    ExtractedDataResponseMetadataToJSON,
    ExtractedDataResponseMetadataToJSONTyped,
} from './ExtractedDataResponseMetadata';

/**
 * Response from metadata extraction (async processing)
 * @export
 * @interface ExtractMetadataResponse
 */
export interface ExtractMetadataResponse {
    /**
     * ID for tracking async processing
     * @type {number}
     * @memberof ExtractMetadataResponse
     */
    documentId: number;
    /**
     * Current processing status
     * @type {string}
     * @memberof ExtractMetadataResponse
     */
    status: ExtractMetadataResponseStatusEnum;
    /**
     * 
     * @type {ExtractedDataResponseMetadata}
     * @memberof ExtractMetadataResponse
     */
    metadata?: ExtractedDataResponseMetadata;
    /**
     * Confidence score for extraction (only present if status is already_completed)
     * @type {number}
     * @memberof ExtractMetadataResponse
     */
    confidence?: number | null;
    /**
     * Model used for extraction (only present if status is already_completed)
     * @type {string}
     * @memberof ExtractMetadataResponse
     */
    model?: string | null;
    /**
     * When extraction was processed (only present if status is already_completed)
     * @type {Date}
     * @memberof ExtractMetadataResponse
     */
    processedAt?: Date | null;
}


/**
 * @export
 */
export const ExtractMetadataResponseStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    MetadataCompleted: 'metadata_completed',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type ExtractMetadataResponseStatusEnum = typeof ExtractMetadataResponseStatusEnum[keyof typeof ExtractMetadataResponseStatusEnum];


/**
 * Check if a given object implements the ExtractMetadataResponse interface.
 */
export function instanceOfExtractMetadataResponse(value: object): value is ExtractMetadataResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ExtractMetadataResponseFromJSON(json: any): ExtractMetadataResponse {
    return ExtractMetadataResponseFromJSONTyped(json, false);
}

export function ExtractMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'status': json['status'],
        'metadata': json['metadata'] == null ? undefined : ExtractedDataResponseMetadataFromJSON(json['metadata']),
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'model': json['model'] == null ? undefined : json['model'],
        'processedAt': json['processedAt'] == null ? undefined : (new Date(json['processedAt'])),
    };
}

export function ExtractMetadataResponseToJSON(json: any): ExtractMetadataResponse {
    return ExtractMetadataResponseToJSONTyped(json, false);
}

export function ExtractMetadataResponseToJSONTyped(value?: ExtractMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'status': value['status'],
        'metadata': ExtractedDataResponseMetadataToJSON(value['metadata']),
        'confidence': value['confidence'],
        'model': value['model'],
        'processedAt': value['processedAt'] == null ? undefined : ((value['processedAt'] as any).toISOString()),
    };
}

